import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=5da1d98c"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=5da1d98c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports